export default {
  location: '当前位置：',
  channels: '支付渠道', accountTab: '对公收款信息',
  title: '平台支付配置', description: '统一管理平台会员套餐购买及资源充值的收款配置。',
  unsaved: '待保存', saved: '已保存', notSaved: '尚未保存配置', cancelChanges: '取消更改', save: '保存配置',
  managedNotice: '微信支付由服务端配置统一管理，此处仅展示配置状态；对公收款账户在本页维护。',
  retry: '重新加载', wechat: '微信支付', offline: '对公转账',
  wechatDescription: '用于平台套餐购买与资源充值', configured: '已配置', notConfigured: '未配置',
  wechatReady: '微信支付配置已就绪', wechatMissing: '微信支付尚未配置完整',
  wechatManaged: '商户信息、密钥及证书由服务端管理，本页不展示或修改。',
  scenes: '适用场景', member_plan: '会员套餐购买', resource_recharge: '资源充值',
  offlineDescription: '企业付款后，由财务核实到账', enableOffline: '启用对公转账',
  accountHelp: '收款单位、开户银行及账号在「对公收款信息」中统一维护。', configureAccount: '配置对公账户',
  accountTitle: '平台对公收款账户', accountDescription: '启用对公转账后，以下账户用于会员套餐购买及资源充值的对公收款。',
  accountName: '收款单位（必填）', bankName: '开户银行（必填）', bankAccount: '银行账号（必填）',
  bankBranch: '开户支行（选填）', financeContact: '财务联系方式（选填）', instructions: '转账说明',
  effectiveTitle: '已生效的付款方式', noMethods: '暂无可用方式',
  savedOnly: '右侧展示已保存的渠道配置。编辑后请点击保存，取消更改可还原至上次保存的内容。',
  related: '相关管理', membershipManagement: '会员套餐管理', rechargeManagement: '充值套餐管理',
  restored: '已还原至上次保存的配置', loadFailed: '加载支付配置失败，请重试。',
  sceneRequired: '启用对公转账时，请至少选择一个适用场景。', accountRequired: '请先完善对公收款账户的必填信息。',
  accountNameRequired: '请填写收款单位', bankNameRequired: '请填写开户银行', bankAccountRequired: '请填写银行账号',
  saveSuccess: '支付配置已保存', saveFailed: '保存失败，请重试。', validationFailed: '收款信息校验失败，请检查必填项及内容长度。'
}
